export const API_ADMIN_GET_ALL_LOG = 'API_ADMIN_GET_ALL_LOG';
export const API_ADMIN_GET_ALL_LOG_SUCCESS = 'API_ADMIN_GET_ALL_LOG_SUCCESS';
export const API_ADMIN_GET_ALL_LOG_FAIL = 'API_ADMIN_GET_ALL_LOG_FAIL';

export const API_ADMIN_GET_FOLDER_LOG = 'API_ADMIN_GET_FOLDER_LOG';
export const API_ADMIN_GET_FOLDER_LOG_SUCCESS =
	'API_ADMIN_GET_FOLDER_LOG_SUCCESS';
export const API_ADMIN_GET_FOLDER_LOG_FAIL = 'API_ADMIN_GET_FOLDER_LOG_FAIL';

export const API_GET_FOLDER_LOG = 'API_GET_FOLDER_LOG';
export const API_GET_FOLDER_LOG_SUCCESS =
	'API_GET_FOLDER_LOG_SUCCESS';
export const API_GET_FOLDER_LOG_FAIL = 'API_GET_FOLDER_LOG_FAIL';

export const ADMIN_RESET_LOGS = 'ADMIN_RESET_LOGS';
